import { InvitationTypes } from './invitation-types';

export interface InvitationModel {
  senderId: string;
  recipientId: string;
  invitationType: InvitationTypes;
}
